import { render, staticRenderFns } from "./VideoAlpha.vue?vue&type=template&id=465c6cd0&scoped=true&"
import script from "./VideoAlpha.vue?vue&type=script&lang=js&"
export * from "./VideoAlpha.vue?vue&type=script&lang=js&"
import style0 from "./VideoAlpha.vue?vue&type=style&index=0&id=465c6cd0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "465c6cd0",
  null
  
)

export default component.exports